import { Appointment } from '../../../domain/entities';
import { FirebaseAppointment } from '../entities';

export class AppointmentMapper {
  static toDomain(firebaseAppointment: FirebaseAppointment): Appointment {
    return new Appointment({
      id: firebaseAppointment.id,
      startDate: firebaseAppointment.startDate.toDate(),
      endDate: firebaseAppointment.endDate.toDate(),
      doctor: firebaseAppointment.doctor,
      patient: firebaseAppointment.patient,
      specialty: firebaseAppointment.specialty
    });
  }
}
